<template>
  <div class="tc-modal-share tc-modal-body">
    <div class="tc-modal-label">
      Поделиться
    </div>
    <div class="tc-modal-input-group">
      <div class="tc-modal-text">
        Ссылка на Ваш проект:
      </div>
      <div class="tc-share-grid">
        <input class="tc-default-input tc-url-input" readonly v-model="url">
        <SquareOutlineButton @click="copyLink">
          <template #icon>
            <SVGCopy/>
          </template>
        </SquareOutlineButton>
      </div>
    </div>
  </div>
</template>

<script>
import SquareOutlineButton from '@/UI/CommonComponents/SquareOutlineButton.vue';
import SVGCopy from '@/UI/SVG/SVGCopy.vue';
import { useStoreUI } from '@/Store/storeUI';
import { useStoreMeta } from '@/Store/storeMeta';

export default {
  name: 'ModalShare',
  components: {
    SVGCopy,
    SquareOutlineButton,
  },
  setup() {
    const storeUI = useStoreUI();
    const storeMeta = useStoreMeta();
    return {
      storeUI,
      storeMeta,
    };
  },
  data() {
    return {
    };
  },
  methods: {
    copyLink() {
      navigator.clipboard.writeText(this.url).then(function() {
          console.log('Текст успешно скопирован в буфер обмена');
      }, function(err) {
          console.error('Не удалось записать текст в буфер обмена: ', err);
      });
    },
  },
  computed: {
    url() {
      if (!this.storeMeta.host) {
        return window.location.href;
      }

      const url = new URL(this.storeMeta.host);

      if (this.$route.query.toolChest) {
        url.searchParams.set('toolChest', this.$route.query.toolChest);
        url.searchParams.set('config', this.$route.query.config ?? '');
      }

      return  url.toString();
    },
  },
  mounted() {

  },
};
</script>

<style scoped lang="scss">
@import "CSS/modal";

.tc-modal-share {
  width: 474px;
}

.tc-url-input{
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.tc-url-input:focus {
  outline: none;
}

</style>

